webpackJsonp([192013037598841],{

/***/ 470:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/projects/interactive-messaging-test/"},"frontmatter":{"title":"Interactive Messaging"}}}]}},"pathContext":{"tag":"messaging"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-messaging-fd9ec5c0fd7c9ff0b81b.js